import * as React from 'react';
import ReactDatePicker from 'react-datepicker';
import InputContainer from 'containers/InputContainer';
import {DatePickerProps as BaseDatePickerProps} from './types';
import Input from '../Input';
import moment, {Moment} from "moment";

export type DatePickerDateArg = Date | [Date | null, Date | null] | null;

export interface DatePickerProps extends Omit<BaseDatePickerProps, "selected"> {
  selected: Date | Moment | string | undefined | null
}

/**
 * The component renders input date time.
 * @param {DatePickerProps} props
 * @return {React.ReactElement<DatePickerProps>}
 * @constructor
 */
export default function DatePicker(
  {
    label,
    note,
    error,
    required,
    ...props
  }: DatePickerProps,
): React.ReactElement<DatePickerProps> {

  /**
   * The function convert moment value to date value
   */
  function getSelectedValue(): Date | null {
    const propsSelected = props.selected;

    return propsSelected
      ? moment(propsSelected).toDate()
      : null
  }

  /**
   * The function prepare and return date picker props
   */
  function getPickerProps():BaseDatePickerProps {
    return {
      ...props,
      selected: getSelectedValue(),
      dateFormat: props.dateFormat || "dd.MM.yyyy",
      timeFormat: props.timeFormat || "HH:mm",
    }
  }

  return (
    <InputContainer
      label={label}
      note={note}
      error={error}
      required={required}
    >
      <ReactDatePicker
        {...getPickerProps()}
        customInput={<Input />}
      />
    </InputContainer>
  );
}
